// config/index.ts
// Backend URL - ZAWSZE używaj api.plexisystem.pl
export const API_URL = 'https://api.plexisystem.pl';

// Nadpisz import.meta.env żeby mieć pewność
if (typeof window !== 'undefined') {
  (window as any).PLEXISYSTEM_API_URL = API_URL;
  (window as any)._API_URL = API_URL;
  
  // Nadpisz import.meta.env
  if (import.meta && import.meta.env) {
    Object.defineProperty(import.meta.env, 'VITE_API_URL', {
      value: API_URL,
      writable: false,
      configurable: false
    });
  }
}

// Eksportuj API_URL jako domyślną wartość
export default API_URL;

// Czy używać mock auth (dla developmentu)
export const USE_MOCK_AUTH = false;

// Mock token dla testów
export const MOCK_JWT_TOKEN = '';
